import { useState, useEffect } from "react";
import api from "api";
import 'styles/quotelinemobile.css';

// ligne de devis simplifiée pour la version mobile ; clic -> écran de préparation matériel
const QuoteLineMobile = (
    {
        quoteid,
        printCancelled,
        onClick,
    }
) => {

    const [ quote, setQuote ] = useState(null);

    useEffect(() => {
        api.get(`quote/${quoteid}`)
        .then(response => {
            const q = response.data;
            q.first_date = new Date(q.first_date);
            q.last_date = new Date(q.last_date);
            setQuote(q);
        });
    }, [quoteid]);

    if (!quote) return null;
    if (quote.cancelled && !printCancelled) return null;

    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const now = new Date();
    const sevenDaysFromNow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

    return (
        <div
            className={
                `QuoteLineMobile
                ${quote.cancelled && "QuoteLineMobileCancelled"}
                ${quote.confirmed && !quote.billed && "QuoteLineMobileConfirmed"}
                ${quote.billed && "QuoteLineMobileBilled"}
            `}
            onClick={onClick}
        >
            <div
                className={
                    `QuoteLineMobileDates
                    ${quote.first_date <= sevenDaysFromNow && !quote.cancelled && !quote.billed && "QuoteLineMobileSoon"}
                `}
            >
                {quote.first_date.toLocaleDateString('fr-FR', options)}
                {
                    quote.last_date.getTime() !== quote.first_date.getTime()
                    &&
                    ` → ${quote.last_date.toLocaleDateString('fr-FR', options)}`
                }
            </div>
            <div className="QuoteLineMobileEvent">{quote.event}</div>
            <div className="QuoteLineMobileClient">{quote.name}</div>
        </div>
    );

};

export default QuoteLineMobile;
